export enum AddressFields {
  Country = "country",
  PersonalAddress = "personalAddress",
  Complement = "complement",
  PostalCode = "postalCode",
  City = "city",
}
